import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';

type DynamicInvoiceDetailProps = {
  label: string;
  value: string | number;
};

export const DynamicInvoiceDetail: React.FC<DynamicInvoiceDetailProps> = ({ label, value }) => (
  <>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="subtitle2" color="textSecondary" sx={{
        fontSize: "14px"
      }}>
        {label}
      </Typography>

      <Typography
        variant="subtitle2"
        color="textPrimary"
        sx={{
          fontSize: "14px",
          ml: 1
        }}>
        {value}
      </Typography>
    </Box>
  </>
);
